import { render, staticRenderFns } from "./image-assets.datatable.vue?vue&type=template&id=30adc882&scoped=true&"
import script from "./image-assets.datatable.vue?vue&type=script&lang=js&"
export * from "./image-assets.datatable.vue?vue&type=script&lang=js&"
import style0 from "./image-assets.datatable.vue?vue&type=style&index=0&id=30adc882&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30adc882",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
